import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sourcesActiveNames: undefined,
  hoveredItem: null,
  clickedItem: null,
}

const alerts = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    setSourceActiveNames: (state, action) => {
      state.sourcesActiveNames = action.payload
    },
    setHoveredItem: (state, action) => {
      state.hoveredItem = action.payload
    },
    setClickedItem: (state, action) => {
      state.clickedItem = action.payload
    },
  },
})

export const {
  setSourceActiveNames,
  setHoveredItem,
  setClickedItem,
} = alerts.actions

export default alerts.reducer
